<template>
    <div class="home">
        <NavBarTherapist v-if="isTherapist"/>
        <NavBar v-else/>
        <v-container fluid v-if="!isTherapist">
            <v-card-text>
                Bienvenid@ al sistema de agendamiento del Centro Psicológico Novo Sol.<br/>
                Si se acaba de registrar, el sistema le envió un correo a la cuenta de email que proporcionó.
                Debe seguir los pasos que ahí se describen para continuar.<br/></v-card-text>
            <v-spacer></v-spacer>
            <v-card-text>Muchas gracias por su atención.<br/>
                <a href="https://www.novo-sol.cl" target="_blank">Centro Psicológico Novo Sol</a>
            </v-card-text>
        </v-container>
    </div>
</template>
<script>
import NavBar from "../components/auth/NavBar";
import NavBarTherapist from "@/components/auth/NavBarTherapist";

export default {
    components: {
        NavBar,
        NavBarTherapist,
    },
    data() {
        return {
            isA: this.$store.getters.isAuthenticated,
            userRoles: this.$store.getters.userRoles
        }
    },
    computed: {
        isTherapist() {
            if (this.userRoles !== null) {
                //console.log(this.userRoles);
                return this.userRoles.includes("ROLE_THERAPIST");
            } else {
                return false;
            }
        }
    }
};
</script>
